<template>
	<div>
		<AutomaticSaleStartSingleConfirmationModal
			v-if="activeStep === confirmationSteps.priceCheck && confirmationData.length === 1"
			:confirmation-data="confirmationData[0]"
			@confirm="confirmSellPrice"
			@close="closeConfirmation"
		/>
		<AutomaticSaleStartMultiConfirmationModal
			v-if="activeStep === confirmationSteps.priceCheck && confirmationData.length > 1"
			:confirmation-data="confirmationData"
			@confirm="confirmSellPrice"
			@close="closeConfirmation"
		/>
	</div>
</template>

<script>
import {receivableApi} from "@/common/api/receivableApi";
import AutomaticSaleStartSingleConfirmationModal from "@/components/templates/seller/sell/AutomaticSaleStartSingleConfirmationModal.vue";
import AutomaticSaleStartMultiConfirmationModal from "@/components/templates/seller/sell/AutomaticSaleStartMultiConfirmationModal.vue";

export default {
	components: { AutomaticSaleStartMultiConfirmationModal, AutomaticSaleStartSingleConfirmationModal },
	data() {
		return {
			confirmationData: null,
			confirmationSteps: {
				priceCheck: "priceCheck",
				withSellPriceSubmitCheck: "withSellPriceSubmitCheck",
				withoutSellPriceSubmitCheck: "withoutSellPriceSubmitCheck",
				confirmed: "confirmed"
			},
			activeStep: null,
			isMultiUpload: false
		};
	},
	methods: {
		showWithReceivable(receivable) {
			this.isMultiUpload = false;

			receivableApi.inspection.loadSingleConfirmationData(receivable)
				.then(res => {
					this.confirmationData = [res];
					this.goToNextStep(this.confirmationSteps.priceCheck);
				})
				.catch(this.toast);
		},
		showWithReceivableIds(ids) {
			this.isMultiUpload = true;

			receivableApi.inspection.loadMultiConfirmationData(ids)
				.then(res => {
					this.confirmationData = res;
					this.goToNextStep(this.confirmationSteps.priceCheck);
				})
				.catch(this.toast);
		},
		getNextStep(step) {
			if (step === this.confirmationSteps.priceCheck) {
				// If automatic start is set, get price confirmation of user
				let saleStartsAutomatically = this.confirmationData.some(data => data.priceCheck.automaticallyStartSale);
				if (saleStartsAutomatically) {
					return this.confirmationSteps.priceCheck;
				} else {
					return this.getNextStep(this.confirmationSteps.withoutSellPriceSubmitCheck);
				}
			}

			if (step === this.confirmationSteps.withoutSellPriceSubmitCheck) {
				let option = {
					title: "",
					msg: this.$t("seller.upload.saveAndSubmit.confirmation"),
					confirmFun: () => this.goToNextStep(this.confirmationSteps.confirmed)
				};
				this.confirmMeg(option, true);

				return this.confirmationSteps.withoutSellPriceSubmitCheck;
			}

			if (step === this.confirmationSteps.withSellPriceSubmitCheck) {
				// No additional confirmation required, going to final confirmed step
				return this.confirmationSteps.confirmed;
			}

			if (step === this.confirmationSteps.confirmed) {
				// No steps after final confirmation, stay in this state
				return this.confirmationSteps.confirmed;
			}
		},
		confirmSellPrice() {
			this.goToNextStep(this.confirmationSteps.withSellPriceSubmitCheck);
		},
		goToNextStep(step) {
			this.activeStep = this.getNextStep(step);

			if (this.activeStep === this.confirmationSteps.confirmed) {
				this.closeConfirmation();
				this.$emit("confirm", this.isMultiUpload ? this.confirmationData : this.confirmationData[0]);
			}
		},
		closeConfirmation() {
			this.activeStep = null;
		}
	},
};
</script>
